import styled, { css } from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;
export const ContentContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;
export const HeaderConfiguration = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 3px;
    margin-top: -10px;

    span {
        margin-left: 10px;

        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 36px;
        display: flex;
        align-items: center;
        color: #FFFFFF;
    }
`
export const ChannelsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 53px;
    box-sizing: border-box;
    padding: 20px;
    border-bottom: 1px solid #A7A7A7;

    div {
        display: flex;
        flex-direction: row;
    }
`;